import type { ExpenseGroup } from '@taler/api-client'

export interface GroupLabels {
  readonly accountLabel: (accountId: string) => string | undefined
  readonly noPayee: string
  readonly untagged: string
  readonly unknownAccount: string
}

export function groupLabelOf(group: ExpenseGroup, labels: GroupLabels): string {
  switch (group.kind) {
    case 'category':
      return labels.accountLabel(group.accountId) ?? labels.unknownAccount
    case 'payee':
      return group.name ?? labels.noPayee
    case 'tag':
      return group.tag
    case 'untagged':
      return labels.untagged
  }
}

/** A stable key for one breakdown row, the same whichever page lists it. */
export function groupKeyOf(group: ExpenseGroup): string {
  switch (group.kind) {
    case 'category':
      return group.accountId
    case 'payee':
      return group.merchantId ?? `payee:${group.name ?? ''}`
    case 'tag':
      return `tag:${group.tag}`
    case 'untagged':
      return 'untagged'
  }
}
